import store from '@/store'
export default {

  // subscribes to the glitch state and triggers the glitch/unglitch funcs
  WatchGlitch(glitchFunc, unglitchFunc) {
    return store.watch((state) => state.projectSynthecite.glitch, (newValue) => {
      // enter/exit glitch
      if (newValue) {
        glitchFunc()
      } else {
        unglitchFunc()
      }
    })
  },
  // subscribes to fullscreen enabled/disable func
  WatchFullscreen(fullscreenFunc, exitFullscreenFunc) {
    // watch on enabled
    return store.watch((state) => state.projectSynthecite.fullscreen.enabled, () => {
      let fullscreen = store.state.projectSynthecite.fullscreen
      if (fullscreen.enabled) {
        fullscreenFunc(fullscreen)
      } else {
        exitFullscreenFunc(fullscreen)
      }
    })
  }
}